import { useProcedureQuery, useTissueQuery } from "../queries";

interface UseTissueProcedureProps {
    procedureId: string | number | undefined;
    tissueId: string | number | undefined;
}

export function useTissueProcedure({ procedureId, tissueId }: UseTissueProcedureProps) {
    const {
        postProcedureEvalQuery: { data: postProcedureEval, isFetching: isPostProcedureEvalFetching },
        detailQuery: { data: procedure, isFetching: isProcedureFetching },
    } = useProcedureQuery({
        queryType: "postProcedureEval",
        id: procedureId,
        tissueId,
    });

    const {
        initialEvalQuery: { data: initialEval, isFetching: isInitialEvalFetching },
        placementQuery: { data: placement, isFetching: isPlacementFetching },
        detailQuery: { data: tissue, isFetching: isTissueFetching },
    } = useTissueQuery({
        includeDetails: true,
        id: tissueId,
    });

    const tissueProcedure = tissue?.tissueProcedures?.find((tp) => tp.procedureId === Number(procedureId));

    const isFetching =
        isPostProcedureEvalFetching ||
        isInitialEvalFetching ||
        isPlacementFetching ||
        isTissueFetching ||
        isProcedureFetching;

    return {
        postProcedureEval,
        isPostProcedureEvalFetching,
        initialEval,
        isInitialEvalFetching,
        placement,
        tissueProcedure,
        isPlacementFetching,
        tissue,
        isTissueFetching,
        procedure,
        isProcedureFetching,
        isFetching,
    };
}
